import { ReactElement } from "react";

// Material-UI
import { useTheme } from "@mui/material/styles";
import { styled } from "@mui/material";
//mouse icons
import MouseBoth from "./mouse-both-click.svg?react";
import MouseLeft from "./mouse-left-click.svg?react";
import MouseMiddle from "./mouse-middle-click.svg?react";
import MouseRight from "./mouse-right-click.svg?react";
import MouseScroll from "./mouse-scroll-wheel.svg?react";

const OCMouseIcon = styled("div")(({ theme }) => ({
  display: "flex",
  "& svg.mouse_icons": {
    width: 20,
    "& path.active_button": {
      fill: theme.palette.primary.main,
    },
    "& path.mouse": {
      fill: theme.palette.grey[400],
    },
    "& path.outline": {
      fill: theme.palette.common.black,
    },
  },
}));

/**
 * A function to return a moise icon
 * @param key -
 * return the matching mouse icon or null
 */
const returnIcon = (key: string): ReactElement => {
  switch (key) {
    case "0":
      return <MouseLeft className="mouse_icons" />;
    case "1":
      return <MouseRight className="mouse_icons" />;
    case "2":
      return <MouseScroll className="mouse_icons" />;
    case "3":
      return <MouseBoth className="mouse_icons" />;
    case "4":
      return <MouseMiddle className="mouse_icons" />;
    default:
      return null;
  }
};

/**
 * a fucntion to return a mouse icon
 * @param keyCode -
 * @returns a mouse icon corresponding to the key parm
 */
export const MouseIcon = (keyCode: string): JSX.Element => {
  const theme = useTheme();

  return <OCMouseIcon>{returnIcon(keyCode)}</OCMouseIcon>;
};
